import React,{useState} from "react";
import { Container, Row, Col, Image, Button, Card } from "react-bootstrap";
import { motion } from "framer-motion";
import { FaFacebook, FaTiktok, FaYoutube, FaInstagram } from "react-icons/fa";
import { Link } from "react-router-dom";
import "./img.css";
import Footer from './footer';
import LatestUpdates from "./latestupdates";

// Animation Variant for Entrance from Left
const fadeInLeft = {
  hidden: { opacity: 0, x: -100 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.5 } },
};

// Animation Variant for Entrance from Right
const fadeInRight = {
    hidden: { opacity: 0, x: 100 }, 
    visible: { opacity: 1, x: 0, transition: { duration: 0.5 } },
  };


const AusVisa = () => {
  return (
    <>
   <Container fluid className="py-5 positon relative">

      {/* Title Section */}
      <motion.h1
        className="text-center text-primary "
        variants={fadeInLeft}
        initial="hidden"
        animate="visible"
      >
        Australian Visa List
      </motion.h1>

      {/* Star Divider */}
      <div className="text-center mb-4">
        <motion.div
          className="d-inline-block text-primary fs-3"
          variants={fadeInLeft}
          initial="hidden"
          animate="visible"
        >
          ⭐
        </motion.div>
      </div>

      <Row className="mt-4 align-items-center">
        {/* Left Image Section */}
        <Col lg={6} className="text-center">
          <motion.div variants={fadeInLeft} initial="hidden" animate="visible">
            <Image
              src="./img/aus-1.jpg" // Use direct src path here
              alt="Workers"
              fluid
              className="rounded"
            />
          </motion.div>
        </Col>

        {/* Right Content Section */}
        <Col lg={6}>
          <motion.div variants={fadeInLeft} initial="hidden" animate="visible">
            <h2 className="text-primary text-center">
              <a href="#" className="text-decoration-underline">
                Working and Skilled Visas
              </a>
            </h2>

            <p className="text-muted text-center">
              PR VISA | TEMPORARY WORKING VISA | BUSINESS VISA | SKILLED MIGRATION
            </p>

            <p className="mt-3">
              This Visa Category includes all <strong>Working, PR, skilled migration program visas</strong>,
              such as Subclass 491, 189, 190, 485, 186, 482, 494 etc. If you are looking for
              <strong> working, business, or permanent residency </strong> in Australia, this is the
              perfect category for you.
            </p>

            <p className="mt-3">
              You can <strong>explore more</strong> from the link below and <strong>contact us</strong> at any time
              to help you with your application for your Visa.
            </p>

            {/* Learn More Button */}
            <div className="text-center">
              <Button variant="warning" className="fw-bold px-4 py-2 mt-3">
                 <Link to="/workingvisa">
                LEARN MORE</Link>
              </Button>
            </div>
          </motion.div>
        </Col>
      </Row>
    </Container>
    <Aus/>
    <Aus1/>
    <Aus2/>
    <Aus3/>
    <Aus4/>
   <MigrationOptions/>
 
   <LatestUpdates/>
   <Footer/>
    </>
  );
};


export default  AusVisa ;


const Aus = () =>{
return(
    <>
    <Container fluid className="py-5 position-relative">
    <Row className="mt-4 align-items-center">
{/* Left Image Section */}
    <Col lg={6}>
          <motion.div variants={fadeInRight} initial="hidden" animate="visible">
            <h2 className="text-primary text-center ">
              <a href="#" className="text-decoration-underline">
              Studying and Training Visas
              </a>
            </h2>

            <p className="text-muted text-center">
            STUDENT  VISA | GUARDIAN  VISA | TRAINING VISA
            </p>

            <p className="mt-3 ms-5">
            This Visa Category includes <strong>Student Visa, </strong>,
            Student Guardian Visa, Training visa,  Subclass 500 , 590 , 407.  If you are looking to 
              <strong> study  in Australia</strong>, This is the perfect Category for you.
            </p>

            <p className="mt-3 ms-5">
              You can <strong>explore more</strong> from the link below and <strong>contact us</strong> at any time
              to help you with your application for your Visa.
            </p>

            {/* Learn More Button */}
            <div className="text-center">
              <Button variant="warning" className="fw-bold px-4 py-2 mt-3">
              <Link to="/studyvisa">Learn More </Link>
              </Button>
            </div>
          </motion.div>
        </Col>
  {/* Right Content Section */}
       
        
        <Col lg={6} className="text-center">
          <motion.div variants={fadeInLeft} initial="hidden" animate="visible">
            <Image
              src="./img/aus-2.jpg" // Use direct src path here
              alt="Workers"
              fluid
              className="rounded"
            />
          </motion.div>
        </Col> 
      </Row>
    </Container>  
    </>
);
}


const Aus1 = () =>{
    return(
        <>
        <Container fluid className="py-5 position-relative">
        <Row className="mt-4 align-items-center">
        {/* Left Image Section */}
        <Col lg={6} className="text-center">
          <motion.div variants={fadeInLeft} initial="hidden" animate="visible">
            <Image
              src="./img/aus-3.jpg" // Use direct src path here
              alt="Workers"
              fluid
              className="rounded"
            />
          </motion.div>
        </Col>

        {/* Right Content Section */}
        <Col lg={6}>
          <motion.div variants={fadeInLeft} initial="hidden" animate="visible">
            <h2 className="text-primary text-center">
              <a href="#" className="text-decoration-underline">
              Family And Partner Visa
              </a>
            </h2>

            <p className="text-muted text-center">
            PR FOR PARENTS VISA |  PARTNER VISA | CHILD VISA 
            </p>

            <p className="mt-3">
            This Visa Category includes all Visa such as  Subclass 820/801, 309/100, 143/173, 804, 864, 838 etc.  If you are planning to bring your <strong>Partner / Parent / Child </strong>
            to Australia or looking to apply <strong>Permanent Residency for them</strong>  in Australia , this is the perfect Category for you.
            </p>

            <p className="mt-3">
              You can <strong>explore more</strong> from the link below and <strong>contact us</strong> at any time
              to help you with your application for your Visa.
            </p>

            {/* Learn More Button */}
            <div className="text-center">
              <Button variant="warning" className="fw-bold px-4 py-2 mt-3">
              <Link to="/family-visa">Learn More </Link>
              </Button>
            </div>
          </motion.div>
        </Col>
      </Row>
        </Container>  
        </>
    );
    }


    const Aus2 = () =>{
    return(
        <>
        <Container fluid className="py-5 position-relative">
        <Row className="mt-4 align-items-center">
{/* Left Image Section */}
    <Col lg={6}>
          <motion.div variants={fadeInRight} initial="hidden" animate="visible">
            <h2 className="text-primary text-center ">
              <a href="#" className="text-decoration-underline">
              Visitor Visas
              </a>
            </h2>

            <p className="text-muted text-center">
            VISITOR  VISA |  WORKING HOLIDAY VISA | TRAINING VISA
            </p>

            <p className="mt-3 ms-5">
            This Visa Category includes <strong>Visitor Visa, </strong>,
            Transit Visa,   
              <strong> Working Holiday visa, </strong>,Subclass 600, 462, 601 , 651 , 417.  If you are looking to If you are looking to <strong>Visit Australia </strong>
              or Planning for<strong>Working Holiday</strong> here, This is the perfect Category for you.
            </p>

            <p className="mt-3 ms-5">
              You can <strong>explore more</strong> from the link below and <strong>contact us</strong> at any time
              to help you with your application for your Visa.
            </p>

            {/* Learn More Button */}
            <div className="text-center">
              <Button variant="warning" className="fw-bold px-4 py-2 mt-3">
              <Link to="/visitorvisa">Learn More </Link>
              </Button>
            </div>
          </motion.div>
        </Col>
  {/* Right Content Section */}
       
        
        <Col lg={6} className="text-center">
          <motion.div variants={fadeInLeft} initial="hidden" animate="visible">
            <Image
              src="./img/aus-4.jpg" // Use direct src path here
              alt="Workers"
              fluid
              className="rounded"
            />
          </motion.div>
        </Col> 
      </Row>
    </Container>  
    </>
    );
}
    

const Aus3 = () =>{
    return(
        <>
        <Container fluid className="py-5 position-relative">
        <Row className="mt-4 align-items-center">
        {/* Left Image Section */}
        <Col lg={6} className="text-center">
          <motion.div variants={fadeInLeft} initial="hidden" animate="visible">
            <Image
              src="./img/aus-5.jpg" // Use direct src path here
              alt="Workers"
              fluid
              className="rounded"
            />
          </motion.div>
        </Col>

        {/* Right Content Section */}
        <Col lg={6}>
          <motion.div variants={fadeInLeft} initial="hidden" animate="visible">
            <h2 className="text-primary text-center">
              <a href="#" className="text-decoration-underline">
              Refugee and Humanitarian Visa
              </a>
            </h2>

            <p className="text-muted text-center">
            PROTECTION VISA | REFUGEE VISA | HUMANITARIAN VISA 
            </p>

            <p className="mt-3">
            This visa category includes all visa such as  Subclass 202 , 866 , 785 , 790 etc.  If you are  <strong> Refugee or need Protection </strong>
            in Australia, this is the perfect category for you.</p>

            <p className="mt-3">
              You can <strong>explore more</strong> from the link below and <strong>contact us</strong> at any time
              to help you with your application for your Visa.
            </p>

            {/* Learn More Button */}
            <div className="text-center">
              <Button variant="warning" className="fw-bold px-4 py-2 mt-3">
              <Link to="/refuge-visa">Learn More </Link>
              </Button>
            </div>
          </motion.div>
        </Col>
      </Row>
        </Container>  
        </>
    );
    }

    const Aus4 = () =>{
        return(
            <>
            <Container fluid className="py-5 position-relative">
            <Row className="mt-4 align-items-center">
        {/* Left Image Section */}
            <Col lg={6}>
                  <motion.div variants={fadeInRight} initial="hidden" animate="visible">
                    <h2 className="text-primary text-center ">
                      <a href="#" className="text-decoration-underline">
                      Other Visas
                      </a>
                    </h2>
        
                    <p className="text-muted text-center">
                    BRIDIGING  VISA| RETIREMENT VISA | SPECIAL CATEGORY VISA
                    </p>
        
                    <p className="mt-3 ms-5">
                    This Visa Category includes <strong>Special Visas </strong>,
                    such as  Subclass 010 , 444 , 602.  If you are looking to  
                      <strong> Visit Australia </strong>for special purpose including<strong> medical treatment</strong>
                      ,This is the perfect Category for you.
                    </p>
        
                    <p className="mt-3 ms-5">
                      You can <strong>explore more</strong> from the link below and <strong>contact us</strong> at any time
                      to help you with your application for your Visa.
                    </p>
        
                    {/* Learn More Button */}
                    <div className="text-center">
                      <Button variant="warning" className="fw-bold px-4 py-2 mt-3">
                      <Link to="/other-visa">Learn More </Link>
                      </Button>
                    </div>
                  </motion.div>
                </Col>
          {/* Right Content Section */}
               
                
                <Col lg={6} className="text-center">
                  <motion.div variants={fadeInLeft} initial="hidden" animate="visible">
                    <Image
                      src="./img/aus-6.jpg" // Use direct src path here
                      alt="Workers"
                      fluid
                      className="rounded"
                    />
                  </motion.div>
                </Col> 
              </Row>
              <motion.button
    initial={{ x: "-100vw", opacity: 0 }}
    animate={{ x: 0, opacity: 1 }}
    transition={{ type: "tween", duration: 0.6, ease: "easeOut" }}
    className="btn btn-danger btn-sm position-fixed bottom-0 start-0 m-3"
    style={{ zIndex: 1050 }}
>
    <i className="bi bi-chat-left-text me-1"></i>
    <a 
        href="https://au.bajwaimmigration.com/book-appointment" 
        className="text-white text-decoration-none"
    >
        Consult Now
    </a>
</motion.button>
            </Container>  
            </>
        );
        }


        const MigrationOptions = () => {
            return (
                <>
                 <Container className="py-5">
                <div>
                <motion.h1
        className="text-center text-primary "
        initial="hidden"
        animate="visible"
      >
       Migration To Other Countries
      </motion.h1>

      {/* Star Divider */}
      <div className="text-center mb-4">
        <motion.div
          className="d-inline-block text-primary fs-3"
          initial="hidden"
          animate="visible"
        >
          ⭐
        </motion.div>
                </div>
                </div>
             
                <Row className="justify-content-center">
                  {/* Canada Migration */}
                  <Col md={5} className="mx-2">
                    <Card className="text-center p-4 shadow-sm bg-light">
                      <h3 className="fw-bold">Canada Migration</h3>
                      <p>
                        Do you want to start your new life in Canada? There are a lot of visa options available for you. Click below to explore more.
                      </p>
                      <Button variant="outline-dark"> <Link to="/canadavisa">Learn More </Link></Button>
                    </Card>
                  </Col>
          
                  {/* USA Migration */}
                  <Col md={5} className="mx-2">
                    <Card className="text-center p-4 shadow-sm bg-light">
                      <h3 className="fw-bold">USA Migration</h3>
                      <p>
                        Do you want to start your new life in the United States? There are a lot of visa options available for you. Click below to explore more.
                      </p>
                      <Button variant="outline-dark">  <Link to="/usavisa">Learn More </Link></Button>
                    </Card>
                  </Col>

                    {/* UK Migration*/}
                    <Col md={5} className="mx-2">
                    <Card className="text-center p-4 shadow-sm bg-light">
                      <h3 className="fw-bold">UK Migration</h3>
                      <p>
                      Do You want to Start your new life in United kingdom. There are a lot of visa options available for you. Click below to explore more.
                      </p>
                      <Button variant="outline-dark"> <Link to="/ukvisa">Learn More </Link> </Button>
                    </Card>
                  </Col>

                  {/* New Zealand Migration*/}
                  <Col md={5} className="mx-2">
                    <Card className="text-center p-4 shadow-sm bg-light">
                      <h3 className="fw-bold">New Zealand Migration</h3>
                      <p>
                      Do You want to Start your new life in New Zealand. There are a lot of visa options available for you. Click below to explore more.
                      </p>
                      <Button variant="outline-dark"> <Link to="/nzvisa">Learn More </Link></Button>
                    </Card>
                  </Col>

                </Row>
              </Container>
              </>
            );
          };
          

        
        
          